<div class="tab-content">
    <!--- Racing Page -->
    <div
        class="container sk-container heuristic-container"
        [ngClass]="{
            'sk-loading':
                applyingParams ||
                (displayNextRaces && !nextRacesLoaded) ||
                (!displayNextRaces ? !featuredLoaded && display === 'featured' : !nextRacesLoaded),
        }">
        <loading-screen
            [displayed]="
                applyingParams ||
                (displayNextRaces && !nextRacesLoaded) ||
                (!displayNextRaces ? !featuredLoaded && display === 'featured' : !nextRacesLoaded)
            "
            [templateType]="'GENERIC'"></loading-screen>
        @if (!applyingParams) {
            <div class="horseracing-tabs" data-crlat="accordionsList">
                @if (display === 'future') {
                    <div>
                        @if (racing.events?.length) {
                            <racing-antepost-tab [defaultAntepostTab]="defaultAntepostTab" [racing]="racing" [isFromOverlay]="isFromOverlay">
                            </racing-antepost-tab>
                        }

                        <!-- Show only when no events -->
                        @if (!responseError && !racing.events?.length) {
                            <no-events></no-events>
                        }
                    </div>
                }
                @if (display === 'featured') {
                    <lazy-component
                        moduleUri="@lazy-modules-module/racingFeatured/racing-featured.module#RacingFeaturedModule"
                        [inputs]="{
                            sportId: categoryId,
                            racing: racing,
                            sectionTitle: sectionTitle,
                            sportName: sportName,
                            eventsOrder: eventsOrder,
                            filter: filter,
                            responseError: responseError,
                            displayNextRaces: nextRacesComponentEnabled,
                            sportModule: sportModule,
                            isExtraPlaceAvailable: isExtraPlaceAvailable,
                            offersAndFeaturedRacesTitle: offersAndFeaturedRacesTitle,
                            hostContext: 'featured-races',
                            compName: 'horseracing',
                        }"
                        [outputs]="['featuredLoaded', 'nextRacesLoaded']"
                        (event)="onFeaturedEvents($event)">
                    </lazy-component>
                }

                <!-- YourCall tab  -->
                @if (display === 'yourcall') {
                    <racing-tab-yourcall [racing]="racing"></racing-tab-yourcall>
                }

                <!-- Special tab -->
                @if (display === 'specials') {
                    <racing-specials-tab [racing]="racing" [eventsOrder]="eventsOrder" [responseError]="responseError"> </racing-specials-tab>
                }
                @if (racingSpecials.length && display === 'featured' && featuredLoaded) {
                    <racing-yourcall-specials [type]="'widget'" [data]="racingSpecials"></racing-yourcall-specials>
                }

                <!-- enhanced multiples carousel -->
                @if (!responseError && display === 'featured' && sportName === 'horseracing' && featuredLoaded) {
                    <racing-enhanced-multiples [isRacingFeatured]="true"></racing-enhanced-multiples>
                }
                @if (
                    !responseError &&
                    targetTab()?.interstitialBanners?.bannerEnabled &&
                    !!lastBannerEnabled() &&
                    !isPreviousUrlFuture &&
                    !isFromOverlay
                ) {
                    <virtual-entry-point-banner [targetTab]="targetTab()" [isUnTiedSport]="true" [sportName]="sportName"></virtual-entry-point-banner>
                }
            </div>
        }
    </div>
</div>
